import { ElementBreadCrumb } from '../../../shared/Components/ElementBreadCrumb';
import { InputTextSearch } from '../../../shared/Components/ElementInputSearch';
import { LanguageTranslate } from '../../../shared/Infraestructure/LanguageTranslate';
import { DtoResponseSelectStockPersonal } from '../Domain/DtoResponseSelectStockPersonal';
import { ElementStockGenerico } from '../../../shared/Components/ElementStockGenerico/ElementStockGenerico';
import './Style.scss';
import ButtonFloating from '../../../shared/Components/ButtonFloating/ButtonFloating';
import { useState } from 'react';
import { OffCanvasBottom } from '../../../shared/Components/ReactBootstrap/OffCanvasBottom/OffCanvasBottom';
import { Filter } from './Filter';
import { useSelector } from 'react-redux';
import { RootState } from '../../../shared/Infraestructure/AdapterStore';

interface PropsViewMain {
    stockPersonalAux: DtoResponseSelectStockPersonal[];
    onChange: (name: string, value: any) => void;
    formSearch: {
        values: any;
        touched: any;
        errors: any;
        handleBlur: Function;
    };
};

// const animatedComponents = makeAnimated();
export const ViewMain = (props: PropsViewMain) => {
    const {
        onChange,
        formSearch,
        stockPersonalAux,
    } = props;

    const languageTranslate = LanguageTranslate();
    const [show, setShow] = useState<boolean>(false)
    const { user } = useSelector((state: RootState) => state.auth)

    return (
        <div className='ViewProfile'>
            <div className="container-fluid">
                {/** BLOQUE DE BREADCRUMB */}
                <ElementBreadCrumb list={[{ text: languageTranslate.moduloMain.textoLogistica, navigate: true, path: '/main/logistica' }, { text: languageTranslate.menu['053'].titulo, navigate: false, path: '' }]} />

                <InputTextSearch
                    name='textSearch'
                    onChange={onChange}
                    values={formSearch.values}
                />

                {stockPersonalAux.map((row, index) => (
                    <ElementStockGenerico
                        key={index}
                        data={row.Item.Nombre}
                        data1={row.Item.Codigo}
                        data3={row.Lote ? row.Lote : '-'}
                        data4={row.TotalStock}
                        text1={languageTranslate.moduloLogistica.stockPersonalTotal.textCodigo}
                        text3={languageTranslate.moduloLogistica.stockPersonalTotal.textLote}
                        linkIcono1={`/main/logistica/stockPersonalTotal/${row.CodigoLlave}`}
                    />
                ))}
            </div>
            {
                user.Pais.Codigo === '504' && (
                    <ButtonFloating
                        onClick={() => setShow(true)}
                        icono='fa-solid fa-filter'
                        colorIcono='#2C3E50'
                    />
                )
            }
            <OffCanvasBottom
                height={25}
                show={show}
                setShow={setShow}
                children={<Filter />}
            />
        </div >
    )
};